module.exports = __webpack_public_path__ + "static/sui-dropdown-10ddbf7ce86cd9700ec7a00fa7d57b30.png";